import React from "react";
import { Box, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";

interface SearchInputProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  searchQuery,
  onSearchChange,
}) => (
  <Box minW={{ base: "140px", md: "auto" }} maxW={{ base: "200px", md: "250px" }}>
    <InputGroup width="full" maxW="full">
      <InputLeftElement pointerEvents="none" height="100%">
        <FiSearch color="#A0AEC0" />
      </InputLeftElement>
      <Input
        placeholder="Search CPT codes (minimum 3 characters)"
        value={searchQuery}
        onChange={onSearchChange}
        pl="2.5rem"
        bg="whiteAlpha.50"
        color="white"
        _placeholder={{ color: "whiteAlpha.500" }}
      />
    </InputGroup>
  </Box>
);
